<template>
  <div class="leader-details">
    <el-row>
      <el-col :span="24">
        <el-descriptions
          class="margin-top"
          :column="1"
          style="width: 100%"
          border
          v-loading="formLoading"
        >
          <el-descriptions-item
            label="姓名"
            :labelStyle="descriptionLableStyle"
            :contentStyle="{ 'text-align': 'center' }"
          >
            <template slot="label"> 姓名 </template>

            <div class="avatar-upload" style="flex-direction: column">
              <el-tag v-if="formData.name" type="success" class="desc-tag name-tag">{{
                `${formData.name} ${formData.nickName ? `(${formData.nickName})` : ''}`
              }}</el-tag>

              <template v-for="(item, index) in formData.avatar">
                <div class="avatar-preview" :key="index">
                  <el-image
                    :fit="'cover'"
                    :preview-src-list="item.url ? [item.url] : [emptyUserImg]"
                    :src="item.url ? item.url : emptyUserImg"
                  ></el-image>
                </div>
              </template>
            </div>
          </el-descriptions-item>
          <el-descriptions-item
            label="出團數"
            :labelStyle="descriptionLableStyle"
            :contentStyle="{ 'text-align': 'center' }"
          >
            <template slot="label"> 出團數 </template>

            <el-tag type="danger" class="desc-tag">
              {{ formData.toursCount ? formData.toursCount : 0 }}</el-tag
            >
          </el-descriptions-item>

          <el-descriptions-item
            label="電話"
            :labelStyle="descriptionLableStyle"
            :contentStyle="{ 'text-align': 'center' }"
          >
            <template slot="label"> 電話 </template>

            <el-tag v-if="formData.mobile" class="desc-tag"> {{ formData.mobile }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item
            label="生日"
            :labelStyle="descriptionLableStyle"
            :contentStyle="{ 'text-align': 'center' }"
          >
            <template slot="label"> 生日 </template>
            <el-tag v-if="formData.birthday" class="desc-tag">
              {{ formData.birthday }}
            </el-tag>
          </el-descriptions-item>

          <el-descriptions-item
            label="姓名"
            :labelStyle="descriptionLableStyle"
            :contentStyle="{ 'text-align': 'center' }"
          >
            <template slot="label"> 領隊相片 </template>

            <div class="avatar-upload" style="flex-direction: row">
              <template v-for="(item, index) in formData.file1">
                <div :key="index">
                  <el-image
                    :fit="'cover'"
                    :preview-src-list="item.url ? [item.url] : [emptyUserImg]"
                    :src="item.url ? item.url : emptyUserImg"
                  ></el-image>
                </div>
              </template>
            </div>
          </el-descriptions-item>

          <el-descriptions-item
            label="介紹"
            :labelStyle="descriptionLableStyle"
            :contentStyle="{ 'text-align': 'center' }"
          >
            <el-input
              :disabled="true"
              type="textarea"
              :rows="7"
              v-model="formData.selfDescription"
            ></el-input>
          </el-descriptions-item>

          <!-- <el-descriptions-item
            label="描述"
            :labelStyle="descriptionLableStyle"
            :contentStyle="{ 'text-align': 'center' }"
          >
            <el-input
              :disabled="true"
              type="textarea"
              :rows="7"
              v-model="formData.description"
            ></el-input>
          </el-descriptions-item> -->

          <el-descriptions-item
            label="經歷"
            :labelStyle="descriptionLableStyle"
            :contentStyle="{ 'text-align': 'center' }"
          >
            <el-input
              :disabled="true"
              type="textarea"
              :rows="7"
              v-model="formData.experience"
            ></el-input>
          </el-descriptions-item>

          <el-descriptions-item
            label="證照說明"
            :labelStyle="descriptionLableStyle"
            :contentStyle="{ 'text-align': 'center' }"
          >
            <div style="display: flex">
              <el-image
                v-for="(item, index) in formData.file2"
                style="
                  width: 200px;
                  height: 200px;
                  display: list-item;
                  margin: 5px;
                  border: 1px solid black;
                "
                :key="index"
                :fit="'cover'"
                :preview-src-list="item.url ? [item.url] : [emptyUserImg]"
                :src="item.url ? item.url : emptyUserImg"
              ></el-image>
            </div>
            <el-input
              :disabled="true"
              type="textarea"
              :rows="7"
              v-model="formData.certificatesRemark"
            ></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getAnTourLeaderByID } from '@/api/agency'

export default {
  name: 'leaderViewData',
  components: {},
  props: {
    // 外部傳入的物件
    agencyCode: {
      type: String,
      default: null,
    },
    userID: {
      type: Number,
      default: null,
    },
    fatherDialogFormVisible: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      emptyUserImg: `${process.env.VUE_APP_S3_LINK}/base/temp_images/empty-user.png`,
      descriptionLableStyle: {
        'text-align': 'right',
        width: '100px',
        'background-color': '#fff4cb',
        'font-family': 'Noto Sans TC, sans-serif, Arial, Microsoft JhengHei !important',
        'font-size': '1.1rem',
        'line-height': '1.75',
      },
      defaultDate: '1990-01-01',
      agencyList: [],
      formLabelWidth: '120px',
      formData: {
        id: null,
        name: '',
        nickName: '',
        birthday: null,
        avatar: [],
        file1: [],
        file2: [],
      },
      formLoading: false,
    }
  },
  watch: {
    userID: async function (value) {
      if (value) {
        await this.getAnTourLeaderByID()
      }
    },
  },
  async created() {
    if (this.userID) {
      await this.getAnTourLeaderByID()
    }
  },
  methods: {
    async getAnTourLeaderByID() {
      let vm = this
      vm.formLoading = true
      let resp = await getAnTourLeaderByID({ id: vm.userID })
      if (resp.success) {
        if (resp.data) {
          vm.formData = resp.data

          const avatar = vm.formData.fileInfo.filter(v => {
            return v.type == 1
          })

          const file1 = vm.formData.fileInfo.filter(v => {
            return v.type == 2
          })
          const file2 = vm.formData.fileInfo.filter(v => {
            return v.type == 3
          })

          if (avatar.length > 0) {
            vm.formData.avatar = avatar[0].files
          } else {
            vm.formData.avatar = []
          }

          if (file1.length > 0) {
            vm.formData.file1 = file1[0].files
          } else {
            vm.formData.file1 = []
          }
          if (file2.length > 0) {
            vm.formData.file2 = file2[0].files
          } else {
            vm.formData.file2 = []
          }

          vm.formLoading = false
        } else {
          vm.formLoading = false
          alert(`該領隊尚未建立資料`)

          vm.fatherDialogFormVisible(false)
        }
      } else {
        vm.formLoading = false
      }
    },
  },
}
</script>

<style>
.leader-details .el-textarea.is-disabled .el-textarea__inner {
  font-family:
    'Noto Sans TC',
    sans-serif,
    Arial,
    Microsoft JhengHei !important;
  font-size: 1.1rem;
  line-height: 1.75;
  color: #1a1a1a;
  font-weight: 300;
  /* font-size: 17px; */
  background-color: snow;
  border-color: #dfe4ed;
  color: steelblue !important;
  cursor: not-allowed;
}
</style>

<style lang="scss" scoped>
.desc-tag {
  font-family:
    'Noto Sans TC',
    sans-serif,
    Arial,
    Microsoft JhengHei !important;
  font-size: 1.1rem;
  line-height: 1.75;
}

.name-tag {
  z-index: 20;
  top: -18px;
}

.avatar-upload {
  // right: 48px;
  // top: 70px;
  // z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  // left: 40px;
  // max-width: 205px;
  .avatar-edit {
    right: 12px;
    z-index: 1;
    top: 10px;
    input {
      display: none;
      + label {
        display: inline-block;
        width: 34px;
        height: 34px;
        margin-bottom: 0;
        border-radius: 100%;
        background: #ffffff;

        border: 1px solid transparent;
        border-color: #fff4cb;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
        cursor: pointer;
        font-weight: normal;
        transition: all 0.2s ease-in-out;
        &:hover {
          background: #f1f1f1;
          border-color: #d6d6d6;
        }
        &:after {
          // content: "\f040";
          // font-family: "FontAwesome";
          color: #757575;
          position: absolute;
          top: 10px;
          left: 0;
          right: 0;
          text-align: center;
          margin: auto;
        }
      }
    }
  }
  .avatar-preview {
    width: 120px;
    height: 120px;
    position: relative;
    border-radius: 100%;
    border: 6px solid #ffe483;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    > div {
      width: 100%;
      height: 100%;
      border-radius: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
}

.el-icon-close {
  color: yellow;
  font-size: 39px;
}
</style>
